let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c3fHZ")).then(() => parcelRequire('guOhA'));